import React, { Component } from 'react'
import MainLogo from 'atoms/MainLogo'
import styled from 'styled-components'
import { ThemeConsumer, themes } from 'contexts/theme-context'
import { ProfileConsumer } from 'contexts/profile-context'
import { ConfigConsumer } from 'contexts/config-context'
import Hamburger from 'images/icons/Hamburger'
import Close from 'images/icons/Close'
import UserProfile from 'molecules/UserProfile'
import NavBar from 'templates/NavBar'
import Accordion from 'molecules/Accordion'
import SHGNWordmark from 'images/icons/shgn/Wordmark'
import { networkNavLinks } from 'tools/user'
import NotificationsBell from 'molecules/NotificationsBell'
import PromoNotifications from 'molecules/PromoNotifications'
import AccordionBody from './components/AccordionBody'
import AccordionTrigger from './components/AccordionTrigger'

const IconWrapper = styled.span`
  width: 24px;
  height: 24px;
  margin: 0 10px;
  display: inline-flex;
`

const CloseWrapper = styled.span`
  width: 24px;
  height: 24px;
  position: absolute;
  top: 8px;
  right: 8px;
`

const MenuWrapper = styled.div`
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: hidden;
    pointer-events: none;
    z-index: 150;
    text-align: left;

    &.nav-is-open {
        pointer-events: auto;
    }
`

const AppMenu = styled.div`
    background-color: #FFF;
    color: #FFF;
    position: fixed;
    max-width: 400px;
    width: 90%;
    height: 100%;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.5);
    transform: translateX(-103%);
    display: flex;
    flex-direction: column;
    will-change: transform;
    z-index: 160;
    pointer-events: auto;
    overflow-y: scroll;

    &.is-animating {
        transition: all 130ms ease-in;
    }

    &.is-open.is-animating {
        transition: all 330ms ease-out;
    }

    &.is-open {
        transform: none;
    }
`

const SHGNDivider = styled.div`
    background: #f2f2f2;
    padding: 8px 24px;
    color: #222;
`

const Underlay = styled.div`
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.4);
    opacity: 0;
    will-change: opacity;
    pointer-events: none;
    transition: opacity 0.3s cubic-bezier(0,0,0.3,1);

    .nav-is-open & {
        opacity: 1;
        pointer-events: auto;
    }
`

const BellWrapper = styled.div`
    margin-left: auto;
    display: flex;
    justify-content: center;
    align-items: center;
`

class MobileHeader extends Component {
  constructor (props) {
    super(props)

    this.state = {
      isNavOpen: false,
    }
    this.menuRef = null
    this.handleHamburgerClick = this.handleHamburgerClick.bind(this)
  }
  handleHamburgerClick (event) {
    return () => {
      this.menuRef.classList.add('is-animating')
      this.menuRef.classList.toggle('is-open')
      this.menuWrapperRef.classList.toggle('nav-is-open')
      document.body.classList.toggle('shgn-scroll-lock')
      document.body.classList.toggle('shgn-nav-is-open')
    }
  }

  componentDidMount () {
    this.menuRef.addEventListener('transitioned', () => {
      this.menuRef.classList.remove('is-animating')
    }, false)
  }

  render () {
    const themesToRender = Object.keys(themes).filter((theme) => themes[theme].showInNetworkNav === true)
    return (
      <ThemeConsumer>
        {theme => (
          <ProfileConsumer>
            {profile => {
              return (
                <ConfigConsumer>
                  {config => {
                    return (
                      <React.Fragment>
                        <MenuWrapper innerRef={ref => { this.menuWrapperRef = ref }}>
                          <Underlay
                            onClick={this.handleHamburgerClick()}
                          />
                          <AppMenu innerRef={ref => { this.menuRef = ref }} className="shgn-mobile-nav-tray" >
                            <CloseWrapper>
                              <Close
                                onClick={this.handleHamburgerClick()}
                              />
                            </CloseWrapper>
                            <UserProfile playableBalance={0} onLinkClick={this.handleHamburgerClick()}/>
                            <SHGNDivider>
                              <SHGNWordmark />
                            </SHGNDivider>
                            {
                              themesToRender.map((theme, index) => {
                                return (
                                  <Accordion
                                    key={`Mobile-NetworkNav-${theme}`}
                                    trigger={
                                      <AccordionTrigger themeName={theme} />
                                    }
                                  >
                                    <AccordionBody links={networkNavLinks(profile.activated_clients, themes[theme])} />
                                  </Accordion>
                                )
                              })
                            }
                          </AppMenu>
                        </MenuWrapper>
                        <NavBar>
                          <IconWrapper>
                            <Hamburger
                              onClick={this.handleHamburgerClick()}
                            />
                          </IconWrapper>
                          <MainLogo wordmark={theme.wordmark} />
                          <BellWrapper>
                            {
                              profile.activated_clients &&
                              <NotificationsBell activatedClients={profile.activated_clients} accessToken={config.accessToken} />
                            }
                          </BellWrapper>
                        </NavBar>
                      </React.Fragment>
                    )
                  }}
                </ConfigConsumer>
              )
            }}
          </ProfileConsumer>
        )}
      </ThemeConsumer>
    )
  }
}

export default MobileHeader



// WEBPACK FOOTER //
// ./src/organisms/Header/MobileHeader/MobileHeader.js